import { jsx as n } from "react/jsx-runtime";
import { C as i, M as p } from "../../index-CZTsB7cN.js";
import { MarketPopover as a } from "../MarketPopover/MarketPopover.js";
import { MarketDropdownContainer as m } from "./subcomponents/MarketDropdownContainer.js";
import { MarketPopoverTrigger as C } from "../MarketPopover/subcomponents/MarketPopoverTrigger.js";
import { MarketPopoverContent as M } from "../MarketPopover/subcomponents/MarketPopoverContent.js";
const r = (o) => {
  const {
    children: t,
    ...e
  } = o;
  return /* @__PURE__ */ n(
    a,
    {
      ...e,
      container: m,
      interaction: { click: !0 },
      offset: p,
      viewportMargin: i,
      children: t
    }
  );
};
r.displayName = "MarketDropdown";
r.Trigger = C;
r.Content = M;
export {
  r as MarketDropdown
};
